export default __webpack_public_path__ + "static/media/Privacy policy.99cdcf09.pdf";